import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// ANT DESIGN IMPORT
import { Layout, Button, Row, Typography, Col, Card, Divider } from "antd";
import { Pie as Pie1 } from "@ant-design/plots";
import { Pie, measureTextWidth } from "@antv/g2plot";

import { PlusOutlined, DollarOutlined, UserOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import MainLayout from "../../components/layouts/MainLayout";
import { BOM } from "../../services/definedMethod";
import { PieChart } from "../../components/facilities/ChartFacility";
import { accountStatus } from "../../components/facilities/AccountFacility";
import { connect } from "react-redux";
const { Content } = Layout;
const { Title } = Typography;

const Dashboard = ({ userData }) => {
  const navigate = useNavigate();

  useEffect(() => {}, []);

  const itemsDropdown = [
    {
      label: "Wallet",
      route: "/wallet-account",
      key: "1",
      // disabled: BOM.HasPermission("READ_SAVINGSACCOUNT"),
      icon: <DollarOutlined />,
    },
    {
      label: "Savings",
      route: "/acc0102",
      key: "2",
      // disabled: BOM.HasPermission("READ_SAVINGSACCOUNT"),
      icon: <DollarOutlined />,
    },
    {
      label: "Loans",
      route: "/acc0103",
      key: "3",
      icon: <DollarOutlined />,
      // danger: true,
    },
  ];
  return (
    <MainLayout>
      <Row style={{ marginBottom: 25, marginTop: 5 }}>
        <Title level={3} style={{ margin: 0, textTransform: "capitalize" }}>
          {BOM.Greet()}
          {userData?.username}
        </Title>
      </Row>
      <Row gutter={16}>
        <Col span={2}></Col>
        <Col span={10}>
          <PieChart
            data={[
              { type: "Active", value: 27 },
              { type: "Closed", value: 25 },
              { type: "Pending", value: 18 },
            ]}
            icon={<UserOutlined className="of-menu-icon" />}
            labelTop={"Service Provider"}
            navigateLink={"service-provider"}
          />
        </Col>
        <Col span={10}>
          <PieChart
            data={[
              { type: "Wallet", value: 2540 },
              { type: "Savings", value: 30000 },
              { type: "Loans", value: 1500 },
            ]}
            icon={<DollarOutlined className="of-menu-icon" />}
            labelTop={"Account"}
            navigateLink={"wallet-account"}
            isDropDownBtn={true}
            itemsDropdown={itemsDropdown}
          />
        </Col>
        <Col span={2}></Col>
      </Row>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps)(Dashboard);
